module.exports = __webpack_public_path__ + "static/media/toggle-menu.2ff23cc2.svg";